<template>
  <div>
    <div class="main">
      <iframe :src="vrsrc"  height="100%" width="100%"  frameborder="0" scrolling="yes" border="0"></iframe>    
    </div>
  </div>
</template>

<script> 

export default {
  name: "VR",
  components: { 
  },
  data() {
    return {
      vrsrc:''
    }
  },
  destroyed() {},
  mounted() { 
  },
  created() {    
    this.vrsrc = this.$route.query.vrsrc;
  },
  methods: { 
  }
};
</script>

<style scoped> 
  .main{    
    position: absolute;
    width: 100%;
    height: calc(100% - 1.37rem);
    font-size: 0;
    overflow-x: hidden;
    overflow-y: scroll;
  }
</style>


// WEBPACK FOOTER //
// src/components/VR.vue